"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var PartnersCtxTreeList_1 = require("./controls/PartnersCtxTreeList");
var PartnersCtxAreaRoot_1 = require("./controls/PartnersCtxAreaRoot");
var PartnersCtxAreaDir_1 = require("./controls/PartnersCtxAreaDir");
var PartnersCtxAreaImg_1 = require("./controls/PartnersCtxAreaImg");
var PartnersContentList = /** @class */ (function (_super) {
    __extends(PartnersContentList, _super);
    function PartnersContentList(props) {
        return _super.call(this, props) || this;
    }
    PartnersContentList.prototype.componentWillMount = function () {
        this.setState({
            areaRenderMode: "none"
        });
    };
    PartnersContentList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.ctxData.LoadData(function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B!"));
            });
        }
    };
    PartnersContentList.prototype.onRootNodeSelect = function (key) {
        this.setState({
            areaRenderMode: "root",
            brandKey: key,
            dirKey: ""
        });
    };
    PartnersContentList.prototype.onDirNodeSelect = function (bKey, dKey) {
        this.setState({
            areaRenderMode: "dir",
            brandKey: bKey,
            dirKey: dKey
        });
    };
    PartnersContentList.prototype.onDirItemSelect = function (bKey, dKey) {
        this.setState({
            areaRenderMode: "dir",
            brandKey: bKey,
            dirKey: dKey
        });
    };
    PartnersContentList.prototype.goBackToDirListClick = function (brandId) {
        this.setState({
            areaRenderMode: "root",
            brandKey: brandId,
            dirKey: ""
        });
    };
    PartnersContentList.prototype.createDirClick = function (brandId) {
        if (this.props.onCreateDirectory) {
            this.props.onCreateDirectory(brandId);
        }
    };
    PartnersContentList.prototype.createFileClick = function (brandId, dirName) {
        if (this.props.onCreateFile) {
            this.props.onCreateFile(brandId, dirName);
        }
    };
    PartnersContentList.prototype.editDirClick = function (brandId, dirName) {
        if (this.props.onEditDirectory) {
            this.props.onEditDirectory(brandId, dirName);
        }
    };
    PartnersContentList.prototype.editFileClick = function (brandId, dirName, fileName) {
        if (this.props.onEditFile) {
            this.props.onEditFile(brandId, dirName, fileName);
        }
    };
    PartnersContentList.prototype.getRenderArea = function () {
        if (this.state.areaRenderMode === "none") {
            return (React.createElement(PartnersCtxAreaRoot_1.default, null));
        }
        if (this.state.areaRenderMode === "root") {
            return (React.createElement(PartnersCtxAreaDir_1.default, { data: this.props.ctxData, brandId: this.state.brandKey, onSelectDirectory: this.onDirItemSelect.bind(this), yesNoDlg: this.props.yesNoDlg, onCreateDirectory: this.createDirClick.bind(this), onEditDirectory: this.editDirClick.bind(this) }));
        }
        if (this.state.areaRenderMode === "dir") {
            return (React.createElement(PartnersCtxAreaImg_1.default, { data: this.props.ctxData, brandId: this.state.brandKey, dirName: this.state.dirKey, onGoBackClick: this.goBackToDirListClick.bind(this), onCreateImage: this.createFileClick.bind(this), onEditImage: this.editFileClick.bind(this), yesNoDlg: this.props.yesNoDlg }));
        }
        throw "No available render for active edit mode -> " + this.state.areaRenderMode;
    };
    PartnersContentList.prototype.render = function () {
        return (React.createElement("div", { style: { height: " calc( 100vh - 165px ) " } },
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "flex-start",
                    height: "100%"
                } },
                React.createElement(PartnersCtxTreeList_1.default, { data: this.props.ctxData, onSelectRootNode: this.onRootNodeSelect.bind(this), onSelectDirNode: this.onDirNodeSelect.bind(this), selectedBrandId: this.state.brandKey, selectedDirName: this.state.dirKey, forceSelectDirMode: this.state.areaRenderMode }),
                this.getRenderArea())));
    };
    return PartnersContentList;
}(React.Component));
exports.default = PartnersContentList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/ui/component/PartnersContentList.tsx
// module id = 2457
// module chunks = 0